/**
 * Registers the slice's translations into the shared "catalogue" namespace.
 *
 * Feature slices add their own keys with addResourceBundle rather than editing
 * the shared locale JSON (see lib/i18n/i18n.ts). Importing this module for its
 * side effect (from index.tsx) is enough.
 */
import i18n from "@/lib/i18n/i18n";

import { catalogueEn } from "./locales/en";
import { catalogueFr } from "./locales/fr";

i18n.addResourceBundle("fr", "translation", { catalogue: catalogueFr }, true, true);
i18n.addResourceBundle("en", "translation", { catalogue: catalogueEn }, true, true);
